export const SERVICE_ID = "service_sh6cj0b"
export const TEMPLATE_ID = "template_3pmye5m"
export const PUBLIC_KEY = "XIMcLh0iWKbyugbzS"
